import { useEffect, useState, type FC } from 'react'
import classnames from 'classnames'
import { Icon, Typography } from 'shared/ui'
import {
  TextField,
  makeTextFieldActionTooltip,
  makeTextFieldAutoFocus,
  makeTextFieldBlurOnEnter,
  makeTextFieldTooltip,
  makeTextFieldLoading,
} from 'shared/ui/TextField'
import { getAriaLabel } from 'shared/lib'
import styles from './styles.module.scss'

type IPhoneInputProps = {
  value: string
  errorText?: string | null
  onBlurField: (value: string) => void
  onChangeValue: (value: string) => void
  isLoading: boolean
  modalView?: boolean
}

export const PhoneInput: FC<IPhoneInputProps> = ({
  value,
  errorText,
  onBlurField,
  onChangeValue,
  isLoading,
  modalView,
}) => {
  const [isError, setIsError] = useState<string | null>(null)

  useEffect(() => {
    setIsError(errorText || null)
  }, [errorText])

  const checkOnBlur = (value: string) => {
    if (!value.length) {
      setIsError('Phone number is required')
    } else {
      onBlurField(value)
    }
  }

  const checkOnChangeValue = (value: string) => {
    setIsError(null)
    onChangeValue(value)
  }

  return (
    <div className={styles.field} aria-label={getAriaLabel('Field')}>
      <span className={styles.label} aria-label={getAriaLabel('Field', 'Label')}>
        <div className={styles.icon} aria-label={getAriaLabel('FieldType', 'Phone')}>
          <Icon icon='phone' />
        </div>
        <Typography
          className={styles.name}
          variant='text-input-field-r'
          tag='div'
          ariaLabel={getAriaLabel('Field', 'NamePhone')}
        >
          Phone
        </Typography>
      </span>
      <div className={styles.fieldContent}>
        <TextField
          className={classnames(styles.value, {
            [styles.modalView]: modalView,
          })}
          size='small'
          variant='outline'
          value={value}
          onBlur={checkOnBlur}
          onChange={checkOnChangeValue}
          InputProps={{ placeholder: 'Enter' }}
          rightActions={[makeTextFieldLoading({ loading: isLoading })]}
          mainActions={[
            makeTextFieldActionTooltip({
              color: 'red',
              placement: 'left',
              active: !!isError,
              message: isError ?? undefined,
              onClick: () => setIsError(''),
            }),
            makeTextFieldTooltip(),
            makeTextFieldAutoFocus({ withFocus: true }),
            makeTextFieldBlurOnEnter(),
          ]}
          ariaLabel={getAriaLabel('Field', 'Value')}
        />
      </div>
    </div>
  )
}
